import {
  AuthService,
  ConfigStateService,
  EnvironmentService,
  SessionStateService,
} from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { eThemeMetronicComponents } from '../../enums/components';

@Component({
  selector: 'hedou-current-user',
  // tslint:disable-next-line: component-max-inline-declarations
  template: `
  <ng-container *ngIf="currentUser$ | async as user">
  <ng-template #loginBtn>
    <a style="height:100%" role="button" class="btn topbar-item" (click)="initLogin()">{{
      'AbpAccount::Login' | abpLocalization
      }}</a>
  </ng-template>
  <div style="height:100%" class="topbar-item" *ngIf="user.isAuthenticated; else loginBtn">
      <div (click)="userOffcanvas.show()" class="btn btn-icon btn-icon-mobile w-auto btn-clean d-flex align-items-center btn-lg px-2" id="kt_quick_user_toggle">
          <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Hi,</span>
          <span class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">{{ user.userName || user.name }}</span>
          <span class="symbol symbol-lg-35 symbol-25 symbol-light-success">
            <span class="symbol-label font-size-h5 font-weight-bold">{{(user.userName || user.name) | firstLetter}}</span>
          </span> 
      </div>
  </div>
  <ki-offcanvas #userOffcanvas title="用户信息">
      <ng-template kiOffcanvasContent>
          这是内容
      </ng-template>
      <!-- <ki-tab title="Tab1">
        <ng-template kiTabContent>haha</ng-template>
      </ki-tab>
      <ki-tab title="Tab2">
        <ng-template kiTabContent>yoyo</ng-template>
      </ki-tab> -->
  </ki-offcanvas>
  <!-- <div style="height:100%" *ngIf="user.isAuthenticated; else loginBtn" class="dropdown btn-group" ngbDropdown placement="bottom-right">
    <a ngbDropdownToggle class="btn pointer topbar-item">
      <abp-current-user-image *abpReplaceableTemplate="{
          componentKey: currentUserImageComponentKey,
          inputs: { currentUser: { value: user }, classes: { value: 'user-avatar' } }
        }" classes="user-avatar"></abp-current-user-image>
      <span class="ml-1">
        <small *ngIf="(selectedTenant$ | async)?.name as tenantName"><i>{{ tenantName }}</i>\</small>
        <span>{{ user.userName || user.name }}</span>
      </span>
    </a>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
      <div class="p-2 row">
        <div class="pr-0 col col-auto">
          <abp-current-user-image *abpReplaceableTemplate="{
              componentKey: currentUserImageComponentKey,
              inputs: { currentUser: { value: user }, classes: { value: 'user-avatar-big' } }
            }" classes="user-avatar-big"></abp-current-user-image>
        </div>
        <div class="pl-2 col">
          <span>{{ 'AbpAccount::Welcome' | abpLocalization }}</span><br />
          <small *ngIf="(selectedTenant$ | async)?.name as tenantName"><i>{{ tenantName }}</i>\</small>
          <strong>{{ ((user.name || '') + ' ' + (user.surName || '')).trim() || user.userName }}</strong>
        </div>
      </div>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item pointer" [href]="manageProfileUrl">{{
        'AbpAccount::ManageYourProfile' | abpLocalization
        }}</a>
      <a class="dropdown-item pointer" [href]="securityLogsUrl">{{
        'AbpAccount::MySecurityLogs' | abpLocalization
        }}</a>
      <a class="dropdown-item pointer" id="logout" (click)="logout()">{{
        'AbpUi::Logout' | abpLocalization
        }}</a>
    </div>
	</div> -->
</ng-container>
`
})
export class CurrentUserComponent {
  currentUser$ = this.configState.getOne$('currentUser');

  selectedTenant$ = this.sessionState.getTenant$();

  currentUserImageComponentKey = eThemeMetronicComponents.CurrentUserImage;

  get smallScreen(): boolean {
    return window.innerWidth < 992;
  }

  get manageProfileUrl() {
    return `${this.issuer}/Account/Manage?returnUrl=${window.location.href}`;
  }

  get securityLogsUrl() {
    return `${this.issuer}/Account/SecurityLogs?returnUrl=${window.location.href}`;
  }

  get issuer() {
    return this.environment.getEnvironment().oAuthConfig.issuer;
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionState: SessionStateService,
    private configState: ConfigStateService,
    private environment: EnvironmentService,
  ) {
    // this.currentUser$.subscribe(console.log)
  }

  initLogin() { 
    this.authService.initLogin();
  }

  logout() {
    this.authService.logout().subscribe();
  }
}
